<template>
  <div>
    <client-profile v-if="isClient()"></client-profile>
    <minimal-profile v-else :editProfileId="editdId"></minimal-profile>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { isClient, SessionStorage } from '@witkac/kartamiejska-shared';

import ClientProfile from '@/views/client/Profile.vue';
import MinimalProfile from '@/views/officials/Profile.vue';
import store from '@/store/store';

/**
 * @vuese
 * Profil
 * @group Profil
 */
export default {
  components: { ClientProfile, MinimalProfile },

  computed: {
    editdId() {
      return parseInt(sessionStorage.getItem(SessionStorage.PROFILE_ID), 10);
    }
  },

  methods: {
    /**
     * @vuese
     * Sprawdza, czy zalogowany użytkownik jest klientem
     */
    isClient
  }
};
</script>
